<div
  class="badge-container"
  iuLoading
  role="button"
  [attr.data-rule]="data()?.rule"
  [dataToWatch]="data"
  (click)="onClick($event)">
  @if (data()?.label) {
    <span class="badge-label">{{ data().label }}</span>
  }

  @if (data()?.hasIcon) {
    <i
      aria-hidden="true"
      [ngClass]="{
        'badge-value': true,
        'icon-checkmark': data()?.rule === 1,
        'icon-cross': data()?.rule === -1,
      }"></i>
  } @else {
    <span class="badge-value" iuNumberAnimation [data]="data().value" [playAnimation]="true">
      {{ data().value }}
    </span>
  }
</div>
